<!-- Start Hero -->
<section class="relative table w-full py-36 bg-[url('/assets/images/parallax/archer_1920x1200.jpg')] bg-center bg-no-repeat">
  <div class="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900"></div>
  <div class="container">
    <div class="grid grid-cols-1 pb-8 text-center mt-10">
      <h3 class="md:text-3xl text-2xl md:leading-snug tracking-wide leading-snug font-medium text-white">{{ 'GUIDES.TITLE' | translate }}</h3>
    </div><!--end grid-->
  </div><!--end container-->
</section><!--end section-->
<!-- End Hero -->

<!-- Start Section-->
<section class="relative md:py-24 py-16">
  <div class="container">
    <div *ngIf="loading" class="flex justify-center items-center py-10">
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-violet-600"></div>
    </div>
    <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px]">
      <div *ngFor="let item of guideCategories" class="">
        <h5 class="font-semibold text-xl">{{item.category}}</h5>
        <ul class="list-none mt-4">
          <li *ngFor="let article of item.articles" class="mt-2 ms-0"><a [routerLink]="['/read', article.id]" (click)="$event.preventDefault()" class="text-slate-400"><i class="mdi mdi-arrow-right text-violet-600 me-2"></i>{{article.title}}</a></li>
        </ul>
      </div>
    </div><!--end grid-->
  </div><!--end container-->
</section><!--end section-->
<!-- End Section-->
